import React from 'react';
import imagen from '../images/temis1.png';
import imagen2 from '../images/temis2.png';
import imagen3 from '../images/temis3.png';
import imagen4 from '../images/law22.png';
import manual1 from '../images/chatManualL.png'
import manual1D from '../images/chatManualD.png'
import manual2 from '../images/filtroManualL.png'
import manual2D from '../images/filtroManualD.png'
import manual2_1 from '../images/filtroManualD.png'
import manual3 from '../images/LeyLight.png'
import manual3D from '../images/LeyDark.png'
import manuel3 from '../images/manuel3.png'
import manuel4 from '../images/manuel4.png'
import manuel5 from '../images/manuel5.png'
import xLight from '../images/xLight.png'; 
import xDark from '../images/xDark.png'; 
import igLight from '../images/igLight.png'; 
import igDark from '../images/igDark.png'; 
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'
import Header from './header';
import '../styles/politica.css'
import '../styles/manual.css'

const Manuel = () => {
    const navigate = useNavigate();
    const { isDarkMode, themeClass, toggleTheme } = useTheme();
    
    const politica = () => navigate('/politica');
    const login = () => navigate('/login');
    const signup = () => navigate('/signup');

    return (
        <div className="main-container Politica">   
            <div className={`header-chat still plan ${themeClass}`}>
                <Header />
                |
                <div className="theme-toggle small-toggle">
                    <span className="colorIconToggle">☼</span>
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={isDarkMode}
                            onChange={toggleTheme}
                            className="toggle-input"
                        />
                        <span className={`toggle-slider ${themeClass}`}>
                            <span className={`toggle-knob ${themeClass}`} />
                        </span>
                    </label>
                    <span className="colorIconToggle">☽</span>
                </div>
            </div>  
            
            <div className="manual-container">
                {/* Hero Section */}
                <div className={`manual-hero ${themeClass}`}>
                    <h1 className="manual-hero-title">Manual de Usuario</h1>
                    <div className="manual-hero-subtitle">Tu guía completa para dominar Temis</div>
                    <p className="manual-hero-description">
                        Temis es una Inteligencia Artificial diseñada para facilitar el acceso y la consulta del marco legal guatemalteco. 
                        Aprende a sacarle el máximo provecho con esta guía interactiva.
                    </p>
                </div>

                {/* Interface Section */}
                <div className={`manual-section ${themeClass}`} id="Interfaz">
                    <div className="section-headerM">
                        <span className={`section-number ${themeClass}`}>01</span>
                        <h2 className="section-titleM">Interfaz</h2>
                    </div>
                    
                    <p className={`section-descriptionM ${themeClass}`}>
                        La interfaz de Temis es intuitiva y se adapta automáticamente al dispositivo que esté utilizando. 
                        Consta de tres componentes principales diseñados para tu comodidad:
                    </p>

                    <div className="interface-cards">
                        <div className={`interface-card ${themeClass}`}>
                            <div className="interface-card-number">1</div>
                            <h3>Espacio de texto</h3>
                            <p>El lugar donde redactas y formulas tus consultas legales de manera libre y natural.</p>
                        </div>
                        <div className={`interface-card ${themeClass}`}>
                            <div className="interface-card-number">2</div>
                            <h3>Botón de generar</h3>
                            <p>Al hacer clic, Temis procesa tu consulta y genera una respuesta basada en el marco legal.</p>
                        </div>
                        <div className={`interface-card ${themeClass}`}>
                            <div className="interface-card-number">3</div>
                            <h3>Activación de filtros</h3>
                            <p>Ajusta preferencias y personaliza tu experiencia según tus necesidades específicas.</p>
                        </div>
                    </div>

                    <div className="image-showcase">
                        <img 
                            src={isDarkMode ? manual1D : manual1} 
                            alt="temisChar" 
                            className="showcase-image"                            
                        />
                    </div>

                    <div className={`tip-box ${themeClass}`}>
                        <div className="tip-icon">💡</div>
                        <div className="tip-content">
                            <strong>Consejo:</strong> Si la primera respuesta no satisface tus necesidades, haz clic nuevamente en '↑'. 
                            Temis puede ofrecer múltiples perspectivas sobre la misma consulta.
                        </div>
                    </div>
                </div>

                {/* Filters Section */}
                <div className={`manual-section ${themeClass}`} id="Filtros">
                    <div className="section-headerM">
                        <span className={`section-number ${themeClass}`}>02</span>
                        <h2 className="section-titleM">Filtros de Documentos</h2>
                    </div>

                    <p className={`section-descriptionM ${themeClass}`}>
                        Ubicado en la parte inferior derecha encontrarás el interruptor de filtrado. Esta herramienta te permite 
                        personalizar los resultados de búsqueda según tus necesidades específicas.
                    </p>

                    <div className="filter-comparison">
                        <div className={`comparison-card ${themeClass}`}>
                            <div className={`comparison-header disabled ${themeClass}`}>
                                <span className="comparison-icon">🔓</span>
                                <h3>Filtro Desactivado</h3>
                            </div>
                            <ul className="comparison-list">
                                <li>Búsqueda en todo el marco legal</li>
                                <li>Respuestas más generales</li>
                                <li>Ideal para exploración amplia</li>
                                <li>Contexto extenso de búsqueda</li>
                            </ul>
                        </div>
                        
                        <div className={`comparison-card ${themeClass}`}>
                            <div className={`comparison-header enabled ${themeClass}`}>
                                <span className="comparison-icon">🔒</span>
                                <h3>Filtro Activado</h3>
                            </div>
                            <ul className="comparison-list">
                                <li>Búsqueda enfocada en documentos seleccionados</li>
                                <li>Respuestas más específicas y detalladas</li>
                                <li>Ideal para temas particulares</li>
                                <li>Contexto preciso y relevante</li>
                            </ul>
                        </div>
                    </div>

                    <div className="image-showcase">
                        <img 
                            src={isDarkMode ? manual2D : manual2} 
                            alt="FiltrosDesactivados" 
                            className="showcase-image"                            
                        />
                    </div>

                    <div className={`info-box ${themeClass}`}>
                        <div className="info-icon">ℹ️</div>
                        <div className="info-content">
                            La base de datos de Temis se encuentra en constante crecimiento. Los documentos mostrados 
                            en el filtro representan nuestra colección actual, que actualizamos regularmente.
                        </div>
                    </div>
                </div>

                {/* Best Practices Section */}
                <div className={`manual-section ${themeClass}`} id="Recomendaciones">
                    <div className="section-headerM">
                        <span className={`section-number ${themeClass}`}>03</span>
                        <h2 className="section-titleM">Mejores Prácticas</h2>
                    </div>

                    <div className="practices-grid">
                        <div className={`practice-card ${themeClass}`}>
                            <div className="practice-header">
                                <span className="practice-icon">❌</span>
                                <h3>Evita preguntar por número de artículo</h3>
                            </div>
                            <p className="practice-description">
                                En lugar de solicitar artículos específicos, puedes simplemente escribir el tema legal que te interesa y Temis localizará la normativa relacionada.
                            </p>
                            <div className={`practice-example wrong ${themeClass}`}>
                                <div className={`example-label ${themeClass}`}>❌ No recomendado</div>
                                <img src={manuel4} alt="Ejemplo incorrecto" />
                            </div>
                            <div className={`practice-example correct ${themeClass}`}>
                                <div className={`example-label ${themeClass}`}>✅ Recomendado</div>
                                <img 
                                    src={isDarkMode ? manual3D : manual3} 
                                    alt="EjemploCorrecto"                            
                                />
                            </div>
                        </div>

                        <div className={`info-box ${themeClass}`}>
                            <div className="info-icon">ℹ️</div>
                            <div className="info-content">
                                Nota: La búsqueda por número de artículo es una función exclusiva del Plan Sabio.
                                Si estás en el plan gratuito o experto, podrás realizar únicamente búsquedas temáticas.
                            </div>
                        </div>

                        <div className={`practice-card ${themeClass}`}>
                            <div className="practice-header">
                                <span className={`section-number ${themeClass}`}>🇬🇹</span>
                                <h3>Evita usar "Guatemala"</h3>
                            </div>
                            <p className="practice-description">
                                Temis está diseñado específicamente para el contexto legal guatemalteco, por lo que incluir 
                                "Guatemala" es redundante y puede generalizar las respuestas.
                            </p>
                        </div>

                        <div className={`practice-card ${themeClass}`}>
                            <div className="practice-header">
                                <span className="practice-icon">🔄</span>
                                <h3>Genera múltiples respuestas</h3>
                            </div>
                            <p className="practice-description">
                                Como IA, Temis puede ofrecer diferentes perspectivas a una misma consulta. Si no estás 
                                satisfecho con la primera respuesta, genera varias hasta encontrar la más útil.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Closing Section */}
                <div className={`manual-closing ${themeClass}`}>
                    <div className="closing-content">
                        <h2>Gracias por confiar en Temis</h2>
                        <p>
                            Como startup emergente, estamos dedicados a mejorar continuamente y expandir nuestras capacidades. 
                            Reconocemos que el camino hacia la comprensión de la ley puede ser complicado, y nuestra meta es 
                            hacerlo más sencillo y accesible para todos.
                        </p>
                        <p>
                            Valoramos enormemente tus comentarios y sugerencias. No dudes en compartir tus pensamientos 
                            y experiencias con nosotros.
                        </p>
                        <div className="closing-signature">
                            De todo corazón, gracias.
                            <br />
                            <strong>— El equipo de Temis</strong>
                        </div>
                    </div>
                </div>

                {/* CTA Section */}
                <div className={`manual-cta ${themeClass}`}>
                    <h1 className="manual-hero-title">¿Listo para comenzar?</h1>
                    <p className="manual-hero-description">Temis, Inteligencia Artificial aplicada a la Ley</p>
                    <button onClick={politica} className={`color-button ${themeClass}`}>
                        Leer Política de Uso
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Manuel;